<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>账号</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="hideInAddShow = false">部门列表</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInAddShow">
      <section class="searchBox">
        <span class="addStyle">
          <a-button
            type="primary"
            icon="plus"
            @click="hideInAddShow = !hideInAddShow"
            >增加</a-button
          >
        </span>
        <span class="searchStyle">
          <div>
            <a-input v-model="nameSearch" placeholder="请输入部门名称" />
          </div>
          <div>
            <a-button type="primary" icon="search" @click="onSearch"
              >搜索</a-button
            >
          </div>
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <a-table
        :columns="columns"
        :dataSource="data"
        bordered
        :pagination="false"
        :loading="loading"
        :rowKey="record => record.department_id"
        class="tableStyle"
      >
        <template
          v-for="col in ['department_name', 'department_id']"
          :slot="col"
          slot-scope="text, record"
        >
          <div :key="col">
            <div v-if="record.editable">
              <a-input
                v-model="record.department_name"
                v-if="col == 'department_name'"
                :value="text"
                @change="
                  e =>
                    handleChange(
                      record.department_name,
                      record.department_id,
                      col
                    )
                "
              />
            </div>
            <div v-else>
              <p>{{ text }}</p>
            </div>
          </div>
        </template>
        <template slot="operation" slot-scope="text, record">
          <div class="editable-row-operations">
            <span v-if="record.editable" class="editStyle">
              <a @click="() => save(record.department_id)">保存</a>
              <a-popconfirm
                title="确定取消？"
                okText="确定"
                cancelText="关闭"
                @confirm="() => cancel(record.department_id)"
              >
                <a>取消</a>
              </a-popconfirm>
            </span>
            <span v-else>
              <a @click="() => edit(record.department_id)">编辑</a>
            </span>
          </div>
        </template>
      </a-table>

      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>

    <!-- 增加 -->
    <addDepartment v-on:hideInAdd="hideInAdd" v-if="hideInAddShow" />
    <!-- 增加 end-->
  </div>
</template>
<script>
const columns = [
  {
    title: "部门名称",
    dataIndex: "department_name",
    scopedSlots: { customRender: "department_name" }
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" }
  }
];
const data = [];
import axios from "axios";
import addDepartment from "@/components/setting/addDepartment"; //增加部门
import { mapState } from "vuex";
export default {
  components: {
    addDepartment
  },
  data() {
    this.cacheData = data.map(item => ({ ...item }));
    return {
      data,
      columns,
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      typeSearch: -1,
      totalPage: "",
      nameSearch: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddShow = msg;
      this.reload();
    },
    onSearch(value) {
      this.page = 1;
      this.getData();
    },
    getData() {
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.customer +
        "Company/departmentList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.nameSearch,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(key) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.department_id)[0];
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    save(key) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.department_id)[0];
      if (target) {
        delete target.editable;
        this.data = newData;
        this.cacheData = newData.map(item => ({ ...item }));
      }
      let url =
        this.httpsBasic.url +
        this.httpsBasic.customer +
        "Company/editeDepartment";
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        department_id: key,
        department_name: target.department_name
      };
      axios
        .post(url, pramas)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("提交成功");
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter(item => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.listContainer {
  background: #fff;
  margin: 20px 2%;
  min-height: 80vh;
  .ant-table {
    min-height: 50vh;
  }
  .breadcrumb {
    padding: 14px 2% 10px;
  }
  .delBtn {
    margin-left: 10%;
    a {
      color: red;
    }
  }
  .editStyle {
    a {
      margin-left: 6%;
    }
    a:last-child {
      color: #999;
    }
  }
  .breadcrumb {
    border-bottom: 1px solid #f0f2f5;
  }
  // 搜索
  // 搜索
  .searchBox {
    padding: 14px 2%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .searchStyle {
      display: inherit;
      // width: 40%;
      > div,
      > span {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-left: 20px;
        > label {
          margin-right: 6px;
          font-size: 14px;
        }
        input {
          display: inline-block;
        }
      }
    }
  }
  .addStyle .ant-btn-primary {
    background-color: #67c23a;
    border-color: #67c23a;
  }
  .tableStyle {
    padding: 0 2%;
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
